<template>
  <Head title="Avid - Password Confirmation" />
  
  <div class="container-fluid d-flex flex-column h-100 onboarding-container">
    <div class="row m-4 justify-content-center onboarding-new align-items-stretch">
        <div class="col-lg-9 col-12">
            <div class="row h-100 justify-content-center align-items-center flex-grow-1">
                <div class="container-fluid col-12">
                    <Link class="navbar-brand" href="/">
                        <img src="/img/logo_png/avid_logo_black.png" alt="Avid" class="navbar-brand-logo-avidonly px-2">
                    </Link>
                </div>
                <div class="registration-form-container col-lg-5 col-12 mt-5 mt-lg-0 d-flex flex-column justify-content-center align-items-stretch">
                    <Link href="/" class="d-block w-100 text-center">
                        <img src="/img/logo_png/logo_tile.png" alt="Avid" class="mb-3" style="width: 50px; height: 50px;">
                    </Link>
                    <h3 class="mb-4">Please confirm your password before continuing.</h3>
                    <form method="POST" action="/password/confirm" class="w-100">
                        <input type="hidden" name="_token" :value="csrfToken">
                        
                        <div class="mb-3">
                            <password-visibility 
                                name="password"
                                placeholder="Password"
                                required
                                autocomplete="current-password"
                                :has-error="!!errors.password"
                                :error-message="errors.password || ''">
                            </password-visibility>
                        </div>

                        <div class="row my-3 text-center">
                            <Link href="/password/reset">
                                Forgot Password?
                            </Link>
                        </div>

                        <div class="row mt-5 mb-3">
                            <div class="col-12">
                                <button type="submit" class="btn btn-primary w-100">
                                    Confirm Password
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-lg-3 d-none d-lg-block bg-with-image"></div>
    </div>
  </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
  errors: {
    type: Object,
    default: () => ({})
  }
});

const csrfToken = computed(() => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'));
</script>

